import { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';

import Button from '../Button/Button';
import Box from '../../Layout/Box/Box';
import { Color } from '../../DataDisplay/Icon/Icon';
import { useDatadogLog } from '../logging';

export type BackButtonProps = {
  variant?: 'angle' | 'arrow' | 'arrowIcon';
  backButtonEnabled?: boolean;
  label?: string;
  size?: 'sm' | 'lg';
  background?: string;
  color?: 'primary' | 'secondary' | 'outlined' | 'none' | 'none-light';
  noShadow?: boolean;
  pageCount?: number;
  iconColor?: Color;
  onClick?: () => void;
};

type FC = FunctionComponent<BackButtonProps>;

const BackButton: FC = (props: BackButtonProps) => {
  const history = useHistory();
  const {
    variant = 'angle',
    backButtonEnabled,
    label = '',
    size = 'sm',
    background = 'transparent',
    noShadow = true,
    color = 'none-light',
    pageCount,
    iconColor = 'primary-dark',

    onClick = () => history.goBack(),
  } = props;
  const log = useDatadogLog();

  return (
    <Box jc="fs" ac="fs" ai="fs">
      {backButtonEnabled && (
        <Button
          id="back-button"
          label={label}
          size={size}
          variant={variant === 'arrow' ? 'outerShadow' : undefined}
          background={variant === 'arrow' ? '#FBFBFB' : background}
          color={variant === 'arrow' ? 'backButton' : color}
          noShadow={variant === 'arrow' ? false : noShadow}
          width={variant === 'arrow' ? '38px' : undefined}
          height={variant === 'arrow' ? '38px' : undefined}
          icon={variant === 'angle' ? 'angleLeft' : 'arrowLeft'}
          iconLocation={variant === 'arrow' ? 'center' : 'left'}
          iconWidth={variant === 'arrow' ? '14px' : undefined}
          iconHeight={variant === 'arrow' ? '14px' : undefined}
          iconSize={variant === 'arrow' ? 'sm' : 'xlg'}
          iconColor={iconColor}
          data-custom="true"
          onClick={() => {
            log({
              message: 'Back button clicked',
              payload: {
                name: 'back',
              },
              actionType: 'Button',
            });
            if (pageCount) {
              history.go(-pageCount);
            } else {
              onClick();
            }
          }}
        />
      )}
    </Box>
  );
};

export default BackButton;
